import {
	Accordion,
	IrradiationIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";

export function IrradiationFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, facets } = useFiltersContext();
	const value = filters.irradiation ?? [];
	const facetCounts = facets?.irradiation;

	const getCount = (irradiationValue: string): number | undefined => {
		if (!facetCounts?.length) return undefined;
		return facetCounts.find((f) => f.value === irradiationValue)?.count ?? 0;
	};

	const sortedIrradiation = useMemo(() => {
		return [...config.irradiation].sort((a, b) => {
			return a.localeCompare(b);
		});
	}, [config.irradiation]);

	return (
		<Accordion.Item
			value="irradiation"
			variant="filter"
			data-testid="irradiation-filter"
		>
			<Accordion.Trigger
				variant="filter"
				data-testid="irradiation-filter-trigger"
			>
				<FilterHeader
					title={t("filters.irradiation")}
					value={Number(value?.length)}
					icon={<IrradiationIcon size={5} />}
					tooltipInfo={t("filters.irradiationInfo")}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2"
					value={value}
					onValueChange={(val) => onFilterChange("irradiation", val)}
				>
					{sortedIrradiation.map((item) => {
						const isSelected = value.includes(item);
						const count = getCount(item);
						const isDisabled = count === 0 && !isSelected;
						return (
							<ToggleGroup.Item
								key={item}
								value={item}
								className="capitalize"
								disabled={isDisabled}
							>
								{/* @ts-ignore: dynamic key generation */}
								{t(`filters.irradiation.${item}`)}
							</ToggleGroup.Item>
						);
					})}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
